import { render, staticRenderFns } from "./alonelAsOverview.vue?vue&type=template&id=06a3bfbb&scoped=true&"
import script from "./alonelAsOverview.vue?vue&type=script&lang=ts&"
export * from "./alonelAsOverview.vue?vue&type=script&lang=ts&"
import style0 from "./alonelAsOverview.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./alonelAsOverview.vue?vue&type=style&index=1&id=06a3bfbb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06a3bfbb",
  null
  
)

export default component.exports